import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import PrepareDataTable from "./PrepareDataTable";
import { VatListContainer, Title } from "./VatList.styled";
import AddEditVat from "../AddEditVat";

import "./VatList.scss";

/**
 * Site List,
 * Path - /sites
 * @see See [Sites Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2944008228/Company+view+page+-+Sites)
 * @component
 */
const VatList = (props) => {
  const { t, columnList, countries } = props;

  const [isAddVatPopupVisible, setAddVatPopupVisible] = useState(false);
  const [isRefreshList, setIsRefreshList] = useState(false);

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  const createNewVat = () => {
    setAddVatPopupVisible(true);
  };
  const closeVatCreationPopup = () => {
    setAddVatPopupVisible(false);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  return (
    <VatListContainer className="vatRate-list">
      <Title>{t("VAT_RATES")}</Title>
      <PrepareDataTable
        isRefreshList={isRefreshList}
        columnList={columnList}
        updateRefeshStatus={updateRefeshStatus}
        createNewVat={createNewVat}
        countries={countries}
      />
      {isAddVatPopupVisible && (
        <AddEditVat
          title={t("VAT_RATE_NEW")}
          onClose={closeVatCreationPopup}
          updateRefeshStatus={updateRefeshStatus}
        />
      )}
    </VatListContainer>
  );
};

VatList.propTypes = {
  t: PropTypes.func.isRequired,
  columnList: PropTypes.arrayOf(PropTypes.string),
};

VatList.defaultProps = {
  columnList: [],
};

export default withTranslation()(VatList);
